import { useEffect, useState } from 'react'
import { api } from '../lib/api'
import { useAuthStore } from '../stores/auth'

interface TenantSettings {
  isDemoTenant?: boolean
  expiresAt?: string | null
}

function formatTimeLeft(expiresAt: string): string {
  const diff = new Date(expiresAt).getTime() - Date.now()
  if (diff <= 0) return 'Истёк'
  const hours = Math.floor(diff / 3_600_000)
  const mins = Math.floor((diff % 3_600_000) / 60_000)
  if (hours > 24) {
    const days = Math.floor(hours / 24)
    return `${days} дн ${hours % 24} ч`
  }
  return hours > 0 ? `${hours} ч ${mins} мин` : `${mins} мин`
}

export function DemoBanner() {
  const user = useAuthStore((s) => s.user)
  const [settings, setSettings] = useState<TenantSettings | null>(null)

  useEffect(() => {
    if (!user) return
    api.get('/tenants/tenant/settings')
      .then((r) => setSettings(r.data.settings))
      .catch(() => {})
  }, [user])

  if (!settings?.isDemoTenant || !settings.expiresAt) return null

  const timeLeft = formatTimeLeft(settings.expiresAt)
  const almostExpired = new Date(settings.expiresAt).getTime() - Date.now() < 6 * 3_600_000

  return (
    <div className={`px-4 py-2 text-sm text-center font-medium ${almostExpired ? 'bg-red-500 text-white' : 'bg-amber-400 text-amber-900'}`}>
      Демо-режим — данные будут удалены через {timeLeft}. Для полного доступа свяжитесь с VeloRent.
    </div>
  )
}
